import CallUp from '@acs1899/tool-callapp'

export const system = () => {
  const u = navigator.userAgent

  let name
  if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('hshhk/android') > -1) {
    name = 'android'
  } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf('hshhk/ios/') > -1) {
    name = 'ios'
  } else {
    name = 'unknown'
  }

  return name
}

export const getUserInfo = (obj) => {
    const name = system();
    const isAndroid = name === 'android'; //android终端
    const isiOS = name === 'ios'; //ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.getBossInfoWithCallback(obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getBossInfoWithCallback && window.webkit.messageHandlers.getBossInfoWithCallback.postMessage(obj);
    }
}

export const getQueryVariable = (key, href) => {
    href = decodeURIComponent(href || window.location.href);
    let match = href.match(new RegExp('[?&]' + key + '=([^&]*)'));
    return match && match[1] && decodeURIComponent(match[1]) || '';
};

let lang = getQueryVariable('lang') || window.localStorage.getItem('lang')

export const isApp = () => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  if (isAndroid) {
    return !!window.HkAndroid
  }

  if (isiOS) {
    return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getBossInfoWithCallback
  }
}

/**
 * 控制顶部导航栏的显示隐藏及透明度
 */
export const toggleTopbar = (alpha) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  let obj = JSON.stringify({alpha})

  if (isAndroid) {
    // 调用原生的分享功能
    window.HkAndroid && window.HkAndroid.setNavibarAlpha(obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setNavibarAlpha && window.webkit.messageHandlers.setNavibarAlpha.postMessage(obj)
  }
}

export const shareFun = (obj) => {
  obj.img = obj.img || `${window.location.origin}${window.location.pathname}/static/xingshan/shareLogo.png`
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  let fun

  // 分享
  if (obj.type === 1) {
    if (isAndroid) {
      fun = 'initShare'
    }

    if (isiOS) {
      fun = 'setShareButton'
    }

    if (obj.url) {
      let _a = document.createElement('a')
      let hasQ = false

      _a.href = obj.url
      hasQ = /\?/.test(_a.hash)
      obj.url = hasQ ? `${obj.url}&lang=${lang}` : `${obj.url}?lang=${lang}`
    }
  }

  // 紧急电话
  if (obj.type === 2) {
    fun = 'setEmergencyButton'
  }
  obj = JSON.stringify(obj)

  if (isAndroid) {
    // 调用原生的分享功能
    window.HkAndroid && window.HkAndroid[fun](obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[fun] && window.webkit.messageHandlers[fun].postMessage(obj)
  }
}

// 是否在微信中
export const isWx = () => {
  return navigator.userAgent.match(/micromessenger/i) ? true : false;
}

// 字符串模板
export const render = (template, context) => {
  return template.replace(/\{\{(.*?)\}\}/g, (match, key) => context[key])
}

// 唤起App
export const callApp = (url) => {
  const _url = url || location.href
  const _a = document.createElement('a')
  const callup = new CallUp({
    // 协议头
    PROTOCAL:'launchmylink',

    HOME: '',

    // 唤起失败时的跳转链接
    FAILBACK: {
      ANDROID: 'market://details?id=com.ChinaMobile',
      IOS: 'https://itunes.apple.com/hk/app/mylink-hk/id483513425?mt=8'
    },

    // Android apk 相关信息
    APK_INFO: {
      PKG: 'com.ChinaMobile',
      CATEGORY: 'android.intent.category.DEFAULT',
      ACTION: 'android.intent.action.VIEW'
    },

    // Universal Link
    // UNIVERSAL: {
    //   HOST: 'https://mylink.hk.chinamobile.com/activity/xingshan'
    // },

    // 唤起超时时间，超时则跳转到下载页面
    LOAD_WAITING: 3000
  })

  _a.href = _url

  callup.loadSchema({
    targetURI: _a.hash.indexOf('?') > -1 ? `${_url}&launchmylink=true` : `${_url}?launchmylink=true`
  })
}




// WEBPACK FOOTER //
// ./src/util/const.js